export default __webpack_public_path__ + "img/breadcrumbs.adaa7dff.svg";